var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.DataTypeNids = {
    get_data_variable: function (data_var, data_site) {
        if (!data_var) {
            return false;
        }
        var out = false;
        if (OCS.Utilities.is_string(data_var)) {
            if (!data_site) {
                return false;
            }
            data_var = {'parm': data_var, 'site': data_site};

        }
        var metadata = this.get_info();
        if(metadata.product === data_var.parm && metadata.radarid === data_var.site) {
            return this.data();
        }
        return false;
    },
    get_variables: function () {
        var metadata = this.get_info();
        return [metadata.product];
    },
    get_variable_units: function () {
        var metadata = this.get_info();
        return metadata.radarid;
    },
    add_data_variable: function () {
        return false;
    },
    is_gridded: function () {
        return false;
    }
};